import React from 'react'

import moment from 'moment'
import styled from 'styled-components'
import { faCalendarExclamation } from '@fortawesome/pro-light-svg-icons'
import { stringToHsl } from '../../Util'

import { ListCardText, ListColor } from '../ListCard/style'
import { ListLMCTextContainer } from './style'
import { CardNavWrapper } from '../ListCard/CardNavWrapper'
import { LastMinutePrice } from '../../../LastMinutes/LastMinutePrice/LastMinutePrice'
import { CategorySection } from '../../../ExtraActivity/Components/ListStructure/Components/CategorySection/CategorySection'
import { useAppSelector } from '../../../store/hooks'
import { useParams } from '../../../Router'

/**
 * OB-506: row layout for the last-minute list item. The previous
 * ListLMContainer (a styled.button) owned this layout; the CardNavWrapper
 * <a> is display:block, so the dot + text need their own flex-row parent.
 */
const RowLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 35px 5px 15px;
  margin: 15px 0;
  width: 100%;
`

type Props = {
  title: string
}

export const LastMinuteListHeader: React.FC<Props> = ({ title }) => {
  const settings = useAppSelector((state) => state.settings.values)
  const lastMinuteList = useAppSelector((state) => state.lastMinute.list)

  const { establishmentId } = useParams<{ [key: string]: string }>()

  const {
    fontColor,
    showPrice,
    highlightColor,
    backgroundColor,
    onlineAppointmentsShowActivitiesWithNoDuration,
  } = settings

  if (typeof lastMinuteList === 'undefined') {
    return null
  }

  const lastMinuteListRender = lastMinuteList.map((lastMinute) => {
    const regularTotal = lastMinute.activities.reduce(
      (total, nextActivity) => total + nextActivity.price,
      0
    )
    /*
     * OB-506: absolute path so the URL is portable when copied via
     * right-click "Copy Link Address" or long-press "Copy link".
     */
    const bookUrl = `/${establishmentId}/last-minutes/${lastMinute.id}/book`
    return (
      <CardNavWrapper
        key={lastMinute.id}
        navType="lastMinute"
        link={bookUrl}
      >
        <RowLayout>
          <ListColor color={stringToHsl(title, 50, 50)} isChild />
          <ListLMCTextContainer>
            <ListCardText fontcolor={highlightColor}>
              {lastMinute.description}
            </ListCardText>
            <ListCardText fontcolor={fontColor}>
              {moment(lastMinute.startsAt).format('LLLL')}
            </ListCardText>
            {lastMinute.activities.map((lmActivity) => {
              if (
                onlineAppointmentsShowActivitiesWithNoDuration === false &&
                lmActivity.startsAt.isSame(lmActivity.endsAt)
              ) {
                return null
              }

              return (
                <ListCardText fontcolor={fontColor}>
                  {lmActivity.name}
                </ListCardText>
              )
            })}
            <LastMinutePrice
              isShowPrice={showPrice}
              fontColor={fontColor}
              regularTotal={regularTotal}
              lastMinutePrice={lastMinute.lastMinutePrice}
            />
          </ListLMCTextContainer>
        </RowLayout>
      </CardNavWrapper>
    )
  })

  return (
    <CategorySection
      title={title}
      list={lastMinuteListRender}
      fontcolor={fontColor}
      icon={faCalendarExclamation}
      highlightColor={highlightColor}
      lastMinuteMenuLine
      bgColor={backgroundColor}
    />
  )
}
